'use client'

/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useState, useEffect } from 'react'
import Image from 'next/image'
import AckoBackground from '@public/images/enterprise/ackoLogoBg.png'
import BusinessModals from '@components/BusinessModal/businessModals'
import { sendEnterpriseEvent } from '@utils/enterpriseSegmentEvent'
import { EVENT_TYPE, TAP_EVENT, VIEW_LEAD_GEN_POPUP } from '@constants/enterpriseSegmentData'
import styles from './enterpriseHeader.module.scss'

const EnterpriseHeader = ({ data }) => {
  const {
    title,
    subtitle,
    partnerSectionTitle,
    partnerLogos,
    actionText,
    categoryInfoList,
    formSnippet
  } = data?.data
  const [isModalOpen, setIsModalOpen] = useState(false)

  useEffect(() => {
    if (isModalOpen) {
      sendEnterpriseEvent({ view_name: VIEW_LEAD_GEN_POPUP }, EVENT_TYPE.VIEW)
    }
  }, [isModalOpen])

  return (
    <div className={styles.header}>
      <div className={styles.ackoLogoBackground}>
        <Image
          src={AckoBackground}
          alt="acko logo"
          loading="lazy"
          height={10}
          width={10}
        />
      </div>
      <h1 className={styles.headerTitle}>{title}</h1>
      <h2 className={styles.headerSubtitle}>{subtitle}</h2>
      <div className={styles.flexContainer}>
        <div className={styles.partnerDetails}>
          <p className={styles.partnerSectionTitle}>{partnerSectionTitle}</p>
          <div>
            {partnerLogos?.data?.map((logo, index) => (
              <Image
                src={logo?.attributes?.url}
                alt="partner icon"
                width={44}
                height={44}
                loading="lazy"
                className={styles.partnerLogo}
                key={index}
              />
            ))}
          </div>
        </div>
        <div
          className={styles.actionButton}
          onClick={() => {
            sendEnterpriseEvent({ action_name: actionText, view_name: VIEW_LEAD_GEN_POPUP, action_type: TAP_EVENT.TAP_LEAD_GEN_POPUP })
            setIsModalOpen(!isModalOpen)
          }}
        >
          {actionText}
        </div>
      </div>
      <div className={styles.categories}>
        {categoryInfoList?.map(item => (
          <a key={item?.title} className={styles.categoryCard} href={`#${item?.category}`}>
            <h4 className={`${styles.categorySubtitle} ${styles[`${item?.category}Subtitle`]}`}>{item?.subtitle}</h4>
            <h3 className={`${styles.categoryTitle} ${styles[`${item?.category}Title`]}`}>{item?.title}</h3>
            <div className={styles.categoryImage}>
              <img
                src={item?.iconUrl?.data?.attributes?.url}
                alt="partner icon"
                loading="lazy"
                className={styles.partnerLogo}
              />
            </div>
            <div className={styles[`${item?.category}RadialBackground`]} />
          </a>
        ))}
      </div>
      <BusinessModals isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} content={formSnippet} />
    </div>
  )
}

export default EnterpriseHeader
